import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHtml5, faCss3Alt, faJs, faReact, faNodeJs, 
  faGit, faBootstrap, faSass, faLinux,
  faPhp, faSymfony, faAngular, faJava, faDocker,
  faAws, faWordpress, faJira, faTrello, 
  faSlack, faConfluence, faLaravel

} from '@fortawesome/free-brands-svg-icons';
import { faDatabase, faCode } from '@fortawesome/free-solid-svg-icons';
import { SiTypescript, SiKubernetes } from 'react-icons/si';
import '../styles/Skills.css';

const Skills = () => {
  const frontendSkills = [
    { name: 'HTML5', icon: faHtml5, level: 95 },
    { name: 'CSS3', icon: faCss3Alt, level: 90 },
    { name: 'JavaScript', icon: faJs, level: 85 },
    { name: 'TypeScript', icon: SiTypescript, level: 85, isReactIcon: true },
    { name: 'React', icon: faReact, level: 80 },
    { name: 'Angular', icon: faAngular, level: 80 },
    { name: 'Bootstrap', icon: faBootstrap, level: 85 },
    { name: 'Sass', icon: faSass, level: 75 },
  ];

  const backendSkills = [
    { name: 'Node.js', icon: faNodeJs, level: 80 },
    { name: 'Php', icon: faPhp, level: 90 },
    { name: 'Symfony', icon: faSymfony, level: 90 },
    { name: 'Wordpress', icon: faWordpress, level: 70 },
    { name: 'Laravel', icon: faLaravel, level: 70 },
    { name: 'Java', icon: faJava, level: 65 },
    { name: 'C#', icon: faCode, level: 80 },
    { name: 'SQL', icon: faDatabase, level: 90 },
    { name: 'MySQL', icon: faDatabase, level: 90 },
    { name: 'MongoDB', icon: faDatabase, level: 65 },
    { name: 'Elasticsearch', icon: faDatabase, level: 65 },
  ];

  const devopsSkills = [
    { name: 'Docker', icon: faDocker, level: 80 },
    { name: 'Kubernetes', icon: SiKubernetes, level: 85, isReactIcon: true },
    { name: 'Docker Compose', icon: faDocker, level: 70 },
    { name: 'AWS', icon: faAws, level: 80 },
  ];
  
  const tools = [
    { name: 'Git/GitHub', icon: faGit, level: 85 },
    { name: 'Jira', icon: faJira, level: 80 },
    { name: 'Trello', icon: faTrello, level: 90 },
    { name: 'Slack', icon: faSlack, level: 90 },
    { name: 'Confluence', icon: faConfluence, level: 90 },
    { name: 'Postman', icon: faCode, level: 90 },
    { name: 'Powershell', icon: faCode, level: 90 },
    { name: 'Linux', icon: faLinux, level: 90 },
  ];

  return (
    <div className="skills-page-container">
      <div className="skills-header">
        <h1 className="skills-title">Mis Habilidades</h1>
        <div className="skills-line"></div>
        <p className="skills-subtitle">Tecnologías y herramientas con las que trabajo</p>
      </div>

      <div className="skills-section">
        <h2>Desarrollo Frontend</h2>
        <div className="skills-list">
          {frontendSkills.map((skill, index) => (
            <div key={index} className="skill-item">
              <div className="skill-icon-container">
                {skill.isReactIcon
                  ? <skill.icon className="skill-icon" />
                  : <FontAwesomeIcon icon={skill.icon} className="skill-icon" />}
              </div>
              <div className="skill-info">
                <div className="skill-name-level">
                  <h3>{skill.name}</h3>
                  <span>{skill.level}%</span>
                </div>
                <div className="skill-bar">
                  <div className="skill-progress" style={{ width: `${skill.level}%` }}></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="skills-section">
        <h2>Desarrollo Backend</h2>
        <div className="skills-list">
          {backendSkills.map((skill, index) => (
            <div key={index} className="skill-item">
              <div className="skill-icon-container">
                <FontAwesomeIcon icon={skill.icon} className="skill-icon" />
              </div>
              <div className="skill-info">
                <div className="skill-name-level">
                  <h3>{skill.name}</h3>
                  <span>{skill.level}%</span>
                </div>
                <div className="skill-bar">
                  <div className="skill-progress" style={{ width: `${skill.level}%` }}></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="skills-section">
        <h2>DevOps & Cloud</h2>
        <div className="skills-list">
          {devopsSkills.map((skill, index) => (
            <div key={index} className="skill-item">
              <div className="skill-icon-container">
                {skill.isReactIcon
                  ? <skill.icon className="skill-icon" />
                  : <FontAwesomeIcon icon={skill.icon} className="skill-icon" />}
              </div>
              <div className="skill-info">
                <div className="skill-name-level">
                  <h3>{skill.name}</h3>
                  <span>{skill.level}%</span>
                </div>
                <div className="skill-bar">
                  <div className="skill-progress" style={{ width: `${skill.level}%` }}></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="skills-section">
        <h2>Herramientas y Otros</h2>
        <div className="skills-list">
          {tools.map((skill, index) => (
            <div key={index} className="skill-item">
              <div className="skill-icon-container">
                <FontAwesomeIcon icon={skill.icon} className="skill-icon" />
              </div>
              <div className="skill-info">
                <div className="skill-name-level">
                  <h3>{skill.name}</h3>
                  <span>{skill.level}%</span>
                </div>
                <div className="skill-bar">
                  <div className="skill-progress" style={{ width: `${skill.level}%` }}></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills; 